// Copy of the accountant workspace (Billing > Accounting). Arabic first; kept apart from billing/admin's
// i18n tree like clientBillingText.js, because `fa` opens this page without the admin console.
const ar = {
  pageTitle: "المحاسبة",
  pageDescription: "الملخص المالي والفواتير والاشتراكات لكل المطاعم التي تصل إليها.",
  refresh: "تحديث",
  print: "طباعة",
  retry: "إعادة المحاولة",
  loading: "جارٍ التحميل…",
  restaurant: "المطعم",
  allRestaurants: "كل المطاعم",
  restaurantsError: "تعذّر تحميل قائمة المطاعم، وتظهر الأرقام لكل المطاعم المتاحة لك.",
  overview: {
    title: "الملخص المالي",
    filtered: "تتبع الأرقام فلاتر الفواتير أدناه.",
    total: "إجمالي الفواتير",
    collected: "المدفوع",
    outstanding: "المتبقي",
    invoices: "عدد الفواتير",
    rate: "نسبة التحصيل",
    partial: "مدفوع جزئيًا",
    review: "قيد المراجعة",
  },
  invoices: {
    title: "الفواتير",
    description: "مرتبطة مباشرة ببيانات الفواتير الفعلية، وأي تحديث عليها يظهر هنا.",
    issue: "إصدار فاتورة",
    export: "تصدير Excel",
    search: "ابحث باسم المطعم أو المعرف أو رقم الفاتورة",
    packageAll: "كل الباقات",
    package: "الباقة",
    from: "من تاريخ",
    to: "إلى تاريخ",
    clear: "مسح الفلاتر",
    sortBy: "ترتيب حسب",
    statusAll: "الكل",
    empty: "لا توجد فواتير مطابقة",
    error: "تعذّر تحميل الفواتير",
    truncated: (count) => `يعرض الجدول أحدث ${count} فاتورة فقط، والملخصات تشمل كل الفواتير. استخدم الفلاتر لتضييق النتائج.`,
    columns: {
      client: "العميل",
      number: "رقم الفاتورة",
      package: "الباقة",
      date: "التاريخ",
      dueDate: "الاستحقاق",
      paymentDate: "آخر دفعة",
      amount: "المبلغ",
      paid: "المدفوع",
      remaining: "المتبقي",
      status: "الحالة",
    },
  },
  status: { unpaid: "غير مدفوعة", partial: "مدفوعة جزئيًا", review: "قيد المراجعة", paid: "مدفوعة", cancelled: "ملغاة" },
  pagination: {
    nav: "التنقل بين الصفحات",
    previous: "السابق",
    next: "التالي",
    summary: (page, pages, total) => `صفحة ${page} من ${pages} · ${total} سجل`,
  },
  subscriptions: {
    title: "الاشتراكات",
    description: (days) =>
      `التواريخ تتبع دورة الفوترة والدفع ولا تُعدَّل يدويًا. قريب الانتهاء: باقي ${days ?? "…"} يوم أو أقل.`,
    all: "الكل",
    active: "فعالة",
    empty: "لا توجد اشتراكات",
    error: "تعذّر تحميل الاشتراكات",
    category: { expired: "منتهي", nearExpiry: "قريب الانتهاء", valid: "سارٍ", pending: "بانتظار التفعيل" },
    platform: "المنصة",
    integration: "التكامل",
    package: "الباقة",
    from: "من",
    to: "إلى",
    remaining: (days) => `باقي ${days} يوم`,
    expiredOn: (date) => `منتهي، آخر يوم ${date || "—"}`,
    scheduledChange: (code, date) => `تغيير مجدول إلى ${code} في ${date}`,
    branches: "الفروع",
    branchStatus: { scheduled: "بانتظار التفعيل", ended: "منتهي", suspended: "موقوف", canceled: "ملغي" },
    changePlan: "تغيير الباقة",
    extend: "تمديد",
    addBranch: "إضافة فرع",
    extendTitle: "تمديد تغطية الفرع",
    extendDescription: "يمدد تاريخ انتهاء تغطية الفرع عبر نظام الفوترة.",
  },
  analytics: {
    title: "التحليلات",
    description: "اختر السنة، ويمكنك تحديد شهر لمراجعة فترة معينة.",
    allMonths: "كل أشهر السنة",
    year: "السنة",
    month: "الشهر",
    error: "تعذّر تحميل التحليلات",
    statusTitle: "توزيع حالات الفواتير",
    monthlyTitle: "الإيرادات المحصّلة شهريًا (ر.س)",
    packageTitle: "الإيرادات حسب الباقة (ر.س)",
    agingTitle: "تقادم الفواتير غير المدفوعة (ر.س)",
    agingNote: "المبالغ غير المدفوعة أو المدفوعة جزئيًا حسب مدة تأخرها، لتحديد من تتابعه أولًا.",
    asOf: (date) => ` (حتى ${date})`,
    invoices: "فاتورة",
    barChart: "رسم بياني بالأعمدة",
    integration: "التكامل",
    other: "أخرى",
    aging: ["0-30 يوم", "31-60 يوم", "61-90 يوم", "أكثر من 90 يوم"],
    months: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
  },
  followUp: {
    title: "متابعة العميل",
    export: "تصدير بيانات المتجر",
    client: "العميل",
    clientId: "معرف العميل",
    city: "المدينة",
    restaurants: "مطاعم ضمن هذا العرض",
    pending: "فواتير تحتاج متابعة",
    lastPayment: "آخر دفعة",
    package: "الباقة الحالية",
    pickOne: "اختر مطعمًا من الفلتر أعلى الصفحة لعرض تفاصيله.",
    field: "البيان",
    value: "القيمة",
  },
  notes: {
    title: "ملاحظات المحاسب",
    add: "إضافة ملاحظة",
    delete: "حذف الملاحظة",
    empty: "لا توجد ملاحظات لهذا المطعم",
    pickOne: "الملاحظات مرتبطة بمطعم محدد. اختر مطعمًا من الفلتر أعلى الصفحة.",
    error: "تعذّر تحميل الملاحظات",
    saveError: "تعذّر حفظ الملاحظة",
    placeholder: "اكتب الملاحظة",
    save: "حفظ",
    cancel: "إلغاء",
    relatedInvoice: (ref) => ` · مرتبطة بفاتورة: ${ref}`,
  },
};

const en = {
  pageTitle: "Accounting",
  pageDescription: "Financial summary, invoices and subscriptions for every restaurant you can reach.",
  refresh: "Refresh",
  print: "Print",
  retry: "Retry",
  loading: "Loading…",
  restaurant: "Restaurant",
  allRestaurants: "All restaurants",
  restaurantsError: "Could not load the restaurant list; figures cover every restaurant you can reach.",
  overview: {
    title: "Financial summary",
    filtered: "Figures follow the invoice filters below.",
    total: "Total billed",
    collected: "Paid",
    outstanding: "Outstanding",
    invoices: "Invoices",
    rate: "Collection rate",
    partial: "Partially paid",
    review: "Under review",
  },
  invoices: {
    title: "Invoices",
    description: "Linked directly to invoice data; any invoice update appears here.",
    issue: "Issue invoice",
    export: "Export Excel",
    search: "Search restaurant, ID or invoice number",
    packageAll: "All packages",
    package: "Package",
    from: "From date",
    to: "To date",
    clear: "Clear filters",
    sortBy: "Sort by",
    statusAll: "All",
    empty: "No matching invoices",
    error: "Could not load invoices",
    truncated: (count) => `Showing the latest ${count} invoices only; summaries include all invoices. Use the filters to narrow the results.`,
    columns: {
      client: "Client",
      number: "Invoice number",
      package: "Package",
      date: "Date",
      dueDate: "Due",
      paymentDate: "Last payment",
      amount: "Amount",
      paid: "Paid",
      remaining: "Remaining",
      status: "Status",
    },
  },
  status: { unpaid: "Unpaid", partial: "Partially paid", review: "Under review", paid: "Paid", cancelled: "Cancelled" },
  pagination: {
    nav: "Pagination",
    previous: "Previous",
    next: "Next",
    summary: (page, pages, total) => `Page ${page} of ${pages} · ${total} records`,
  },
  subscriptions: {
    title: "Subscriptions",
    description: (days) =>
      `Dates follow the billing and payment cycle and are not edited by hand. Near expiry: ${days ?? "…"} days or less remaining.`,
    all: "All",
    active: "Active",
    empty: "No subscriptions",
    error: "Could not load subscriptions",
    category: { expired: "Expired", nearExpiry: "Near expiry", valid: "Valid", pending: "Pending activation" },
    platform: "Platform",
    integration: "Integration",
    package: "Package",
    from: "From",
    to: "To",
    remaining: (days) => `${days} days remaining`,
    expiredOn: (date) => `Expired, last day ${date || "—"}`,
    scheduledChange: (code, date) => `Scheduled change to ${code} on ${date}`,
    branches: "Branches",
    branchStatus: { scheduled: "Waiting for activation", ended: "Ended", suspended: "Suspended", canceled: "Canceled" },
    changePlan: "Change package",
    extend: "Extend",
    addBranch: "Add branch",
    extendTitle: "Extend branch coverage",
    extendDescription: "Extends the branch coverage end date through the billing system.",
  },
  analytics: {
    title: "Analytics",
    description: "Choose a year and optionally a month to review a specific period.",
    allMonths: "All months",
    year: "Year",
    month: "Month",
    error: "Could not load analytics",
    statusTitle: "Invoice status distribution",
    monthlyTitle: "Monthly collected revenue (SAR)",
    packageTitle: "Revenue by package (SAR)",
    agingTitle: "Unpaid invoice aging (SAR)",
    agingNote: "Unpaid and partially paid amounts by how long they have been outstanding.",
    asOf: (date) => ` (as of ${date})`,
    invoices: "Invoices",
    barChart: "Bar chart",
    integration: "Integration",
    other: "Other",
    aging: ["0-30 days", "31-60 days", "61-90 days", "Over 90 days"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  },
  followUp: {
    title: "Client follow-up",
    export: "Export store data",
    client: "Client",
    clientId: "Client ID",
    city: "City",
    restaurants: "Restaurants in this view",
    pending: "Invoices requiring follow-up",
    lastPayment: "Last payment",
    package: "Current package",
    pickOne: "Choose a restaurant from the filter at the top of the page to see its details.",
    field: "Field",
    value: "Value",
  },
  notes: {
    title: "Accountant notes",
    add: "Add note",
    delete: "Delete note",
    empty: "No notes for this restaurant",
    pickOne: "Notes belong to one restaurant. Choose a restaurant from the filter at the top of the page.",
    error: "Could not load notes",
    saveError: "Could not save the note",
    placeholder: "Write the note",
    save: "Save",
    cancel: "Cancel",
    relatedInvoice: (ref) => ` · Related invoice: ${ref}`,
  },
};

export const accountantText = (lang) => (lang === "en" ? en : ar);
